import type { IconSvgObject } from './types';

const WThreeSchoolsIcon: IconSvgObject = [
  ["path", { d: "M6 8H2L8 18L12.5 11L17 18L19 14.5L15 8H10L8 11L6 8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 6H22L20 8H20.5C21.3284 8 22 8.67157 22 9.5C22 10.3284 21.3284 11 20.5 11C19.8469 11 19.2059 10.5826 19 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WThreeSchoolsIcon;
